import { ModalId } from "../../../../../../shared/enums/modalId";
import { setOpenedModalId } from "../../../../../redux/slice/modalSlice";
import store from "../../../../../redux/store/store";

export const uploadGridClick = () => {
  store.dispatch(
    setOpenedModalId({
      id: ModalId.NAR_INGESTION_UPLOAD_MODAL,
    }),
  );
};
